import { render } from "./SpjIndex.vue?vue&type=template&id=45d5d9c4"
import script from "./SpjIndex.vue?vue&type=script&lang=js"
export * from "./SpjIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__